module.exports = __webpack_public_path__ + "media/images/ui__infoOk-4ffc7f1c2caff09d42ef66fb9a560ac8.png";